import type { ReactNode } from "react";
import { MySpaceEventStats } from "./ms-event-stats";

export const MsEventSharedLayout = ({ children }: { children: ReactNode }) => {
  return (
    <section className="flex flex-col gap-4 flex-1">
      <MySpaceEventStats />
      {children}
    </section>
  );
};
